var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('mixed-table',{attrs:{"data":_vm.data,"columns":_vm.columns,"fetch-data":_vm.getData,"row-clicked":_vm.selectData,"reload-table":_vm.reloadTable}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }